import axiosInstance from './axios.service';

class RifaService {
  async getRifas(skip, limit) {
    const { data } = await axiosInstance.get(`/api/rifas/${skip}/${limit}`);
    return data;
  }

  async getRifa(id) {
    const { data } = await axiosInstance.get(`/api/rifas/${id}`);
    return data;
  }

  async createRifa(rifa) {
    const { data } = await axiosInstance.post('/api/rifas', rifa);
    return data;
  }

  async updateRifa(id, rifa) {
    const { data } = await axiosInstance.put(`/api/rifas/${id}`, rifa);
    return data;
  }

  async deleteRifa(id) {
    const { data } = await axiosInstance.delete(`/api/rifas/${id}`);
    return data;
  }

  async getRifaStats(id) {
    const { data } = await axiosInstance.get(`/api/rifas/stats/${id}`);
    return data;
  }

  async getRifaTickets(id, skip, limit) {
    const { data } = await axiosInstance.get(`/api/rifas/${id}/tickets/${skip}/${limit}`);
    return data;
  }

  async getRifaWinners(id) {
    const { data } = await axiosInstance.get(`/api/rifas/${id}/winners`);
    return data;
  }

  async downloadTicketPreview(id, { isPreview = true } = {}) {
    const { data } = await axiosInstance.get(`/api/rifas/ticketPreview/${id}`, {
      params: { isPreview },
      responseType: 'arraybuffer',
    });
    return data;
  }

  /** Ticket PDF block layout: { layout, defaultLayout, isDefault, optionSchema } */
  async getPdfLayout(id) {
    const { data } = await axiosInstance.get(`/api/rifas/${id}/pdfLayout`);
    return data;
  }

  /** pdfLayout = null resets the raffle to the default design */
  async savePdfLayout(id, pdfLayout) {
    const { data } = await axiosInstance.put(`/api/rifas/${id}/pdfLayout`, { pdfLayout });
    return data;
  }

  /** Ticket HTML rendered with an unsaved layout + N sample numbers (for the editor iframe) */
  async previewPdfLayoutHtml(id, { pdfLayout, sampleCount }, { signal } = {}) {
    const { data } = await axiosInstance.post(
      `/api/rifas/${id}/pdfLayout/preview`,
      { pdfLayout, sampleCount, format: 'html' },
      { responseType: 'text', signal }
    );
    return data;
  }

  /** Real Puppeteer PDF rendered with an unsaved layout (ArrayBuffer) */
  async previewPdfLayoutPdf(id, { pdfLayout, sampleCount }) {
    const { data } = await axiosInstance.post(
      `/api/rifas/${id}/pdfLayout/preview`,
      { pdfLayout, sampleCount, format: 'pdf' },
      { responseType: 'arraybuffer' }
    );
    return data;
  }
}

export default new RifaService();
